export abstract class Service {
    public abstract init(): void;
}
